module.exports = __webpack_public_path__ + "static/media/solution-tube-k-full-closed.506ce6a2.svg";